module.exports = __webpack_public_path__ + "img/player-fullscreen-icon.0ad4a1df.svg";